import { gql } from '@apollo/client';

export default gql`
  {
    LastProjectsFinisheds {
        id
            name
            state
            userId
            createdAt
            updatedAt
            finishedAt
            user {
                Usuario
            }
    }
  }
`;